import React from 'react';
import PropTypes from 'prop-types';

import StyledModal, { ModalActions } from '../Modal';
import Button from '../Button';
import SinglePhotoManager from './SinglePhotoManager';
import * as Icons from '../icons/Icons';

import { IMAGE_SHAPE, CROPPED_IMAGE_SHAPE, UPLOAD_MANAGER_SHAPE } from './shapes';
import { FlexCol, FlexRow } from '../FlexGrid';
import Heading from '../Heading';

export default class PreviewImage extends React.Component {
    static propTypes = {
        originalImage: IMAGE_SHAPE,
        croppedImage: CROPPED_IMAGE_SHAPE,
        altText: PropTypes.string,
        caption: PropTypes.string,
        credit: PropTypes.string,
        hasHeroImage: PropTypes.bool,
        uploadManager: UPLOAD_MANAGER_SHAPE.isRequired,
        getHeroImage: PropTypes.func.isRequired,
        onPublish: PropTypes.func,
        onDelete: PropTypes.func,
        onReload: PropTypes.func
    };

    static defaultProps = {
        originalImage: {},
        croppedImage: {},
        altText: '',
        caption: '',
        credit: '',
        hasHeroImage: false,
        onPublish: () => { },
        onDelete: () => { },
        onReload: () => { }
    };

    state = {
        isHelpModalOpen: false
    };

    shouldComponentUpdate(nextProps, nextState) {
        if (
            nextProps.originalImage.source !== this.props.originalImage.source ||
            nextProps.croppedImage.source !== this.props.croppedImage.source ||
            nextProps.altText !== this.props.altText ||
            nextProps.caption !== this.props.caption ||
            nextProps.credit !== this.props.credit ||
            nextProps.hasHeroImage !== this.props.hasHeroImage ||
            nextState.isHelpModalOpen !== this.state.isHelpModalOpen
        ) {
            return true;
        }
        return false;
    }

    toggleHelpModal = () => {
        this.setState({ isHelpModalOpen: !this.state.isHelpModalOpen });
    };

    onUpdate = () => {

    }

    render() {
        const { isHelpModalOpen } = this.state;

        return (
            <div className="rec-photo-upload-page-section">
                <FlexRow alignItems="center" hasGutters={false} className='rec-photo-upload-page-section-heading'>
                    <FlexCol xs="variable">
                        <Heading headingLevel={2} appearance="h4">
                            Preview Image
                        </Heading>
                    </FlexCol>
                    <FlexCol>
                        <Button
                            className="rec-photo-upload-page-section-helptip-trigger"
                            onClick={this.toggleHelpModal}
                            appearance="subtle"
                            size="sm"
                            iconBeforeElement={<Icons.IconInfo  />}
                            screenReaderTextBefore="Preview Image Example" />
                    </FlexCol>
                </FlexRow>

                <SinglePhotoManager
                    id="preview"
                    imageType="preview"
                    imageTypeDisplay="Preview Image"
                    desiredWidth={700}
                    desiredHeight={524}
                    isFreeformCrop={false}
                    onUpdate={this.onUpdate}
                    showCropOnSelect
                    {...this.props} />

                <StyledModal
                    heading="Preview Image"
                    size="lg"
                    isOpen={isHelpModalOpen}
                    onRequestClose={this.toggleHelpModal}>
                    <FlexRow className="rec-photo-help-modal-content">
                        <FlexCol sm={5} className="rec-photo-help-modal-left-col mb-2 md-sm-0">
                            <img src={`${process.env.CDN}/img/global/photo-manager/preview-img-example.jpg`} alt="example preview" />
                        </FlexCol>
                        <FlexCol sm={7}>
                            <p>
                                After you&rsquo;ve added a hero image for your location, you&rsquo;ll need to select your preview image. The preview
                                image is a smaller-scale promotional image of your location that appears next to your inventory description in search
                                results on the website.
                            </p>
                            <p>
                                Our photo tool provides the option to upload a separate preview image or use the same photo as your hero image. You can
                                click the &ldquo;Upload Promo Image&rdquo; button to add a new preview image or the &ldquo;Use the Hero Image&rsquo;
                                button to reapply the hero image and information provided in the previous section for your promotional photo. You can
                                also edit or refocus your preview image using the cropping tool. If you choose to upload a different preview image,
                                please ensure you add alternative text, caption text, and source information for the photo.
                            </p>
                        </FlexCol>
                    </FlexRow>
                    <ModalActions>
                        <Button onClick={this.toggleHelpModal}>
                            Close
                        </Button>
                    </ModalActions>
                </StyledModal>
                <hr />
            </div>
        );
    }
}
